import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_SCHOOLS_LISTING,
    ADD_SCHOOLS,
    UPDATE_SCHOOLS,
    DELETE_SCHOOLS,
    BULK_DELETE_SCHOOLS,
    EXPORT_SCHOOLS,
    GET_SCHOOLS_DETAILS,
} from "./actionTypes.js";

import {
    getSchoolsListingSuccess,
    getSchoolsListingFail,
    getSchoolsDetailsSuccess,
    createSchoolsSuccess,
    createSchoolsFail,
    updateSchoolsSuccess,
    updateSchoolsFail,
    deleteSchoolsSuccess,
    deleteSchoolsFail,
    bulkDeleteSchoolsSuccess,
    bulkDeleteSchoolsFail,
    exportSchoolsSuccess,
    exportSchoolsFail,
    getSchoolsDetailsFail,
} from "./actions.js";

import {
    schoolsListingApi,
    schoolsDetailsApi,
    addSchoolsApi,
    updateSchoolsApi,
    deleteSchoolsApi,
    bulkDeleteSchoolsApi,
    exportSchoolsApi,
} from "./schoolApi.js";

function* fetchSchoolsListing({ payload }) {
    try {
        const response = yield call(schoolsListingApi, payload);
        yield put(getSchoolsListingSuccess(response));
    } catch (error) {
        yield put(getSchoolsListingFail(error));
    }
}

function* fetchSchoolsDetail({ payload }) {
    try {
        const response = yield call(schoolsDetailsApi, payload);
        yield put(getSchoolsDetailsSuccess(response));
    } catch (error) {
        yield put(getSchoolsDetailsFail(error));
    }
}

function* createSchools({ payload }) {
    try {
        const response = yield call(addSchoolsApi, payload);
        yield put(createSchoolsSuccess(response));
    } catch (error) {
        yield put(createSchoolsFail(error));
    }
}

function* updateSchools({ payload }) {
    try {
        const response = yield call(updateSchoolsApi, payload);
        yield put(updateSchoolsSuccess(response));
    } catch (error) {
        yield put(updateSchoolsFail(error));
    }
}

function* deleteSchools({ payload }) {
    try {
        const response = yield call(deleteSchoolsApi, payload);
        yield put(deleteSchoolsSuccess(response));
    } catch (error) {
        yield put(deleteSchoolsFail(error));
    }
}

function* bulkDeleteSchools({ payload }) {
    try {
        const response = yield call(bulkDeleteSchoolsApi, payload);
        yield put(bulkDeleteSchoolsSuccess(response));
    } catch (error) {
        yield put(bulkDeleteSchoolsFail(error));
    }
}

function* exportSchools({ payload }) {
    try {
        const response = yield call(exportSchoolsApi, payload);
        yield put(exportSchoolsSuccess(response));
    } catch (error) {
        yield put(exportSchoolsFail(error));
    }
}

function* SchoolsSaga() {
    yield takeEvery(GET_SCHOOLS_LISTING, fetchSchoolsListing);
    yield takeEvery(GET_SCHOOLS_DETAILS, fetchSchoolsDetail);
    yield takeEvery(ADD_SCHOOLS, createSchools);
    yield takeEvery(UPDATE_SCHOOLS, updateSchools);
    yield takeEvery(DELETE_SCHOOLS, deleteSchools);
    yield takeEvery(BULK_DELETE_SCHOOLS, bulkDeleteSchools);
    yield takeEvery(EXPORT_SCHOOLS, exportSchools);

}

export default SchoolsSaga
